import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { Observable } from 'rxjs';
import { ResponseApiDto } from '../../DTOs/_response-api.dto';

@Injectable({
    providedIn: 'root',
})
export class DocumentPdfApi {
    private prefix = 'document/pdf';
    private _httpClient = inject(HttpClient);

    /**
     * Solicita a geração do PDF do documento
     * @param _id ID of document
     * @returns Observable of ResponseApiDto<void>
     */
    public request(_id: string): Observable<ResponseApiDto<void>> {
        const url = `${environment.API_BASE}${this.prefix}/request/${_id}`;

        return this._httpClient.patch<ResponseApiDto<void>>(url, null);
    }

    /**
     * Cobra o download feito pela prévia do editor (impressão local, sem engine).
     * 402 quando não há saldo: nesse caso o download não deve acontecer.
     * @param _id ID of document
     */
    public chargePreviewDownload(_id: string): Observable<ResponseApiDto<void>> {
        const url = `${environment.API_BASE}${this.prefix}/preview-download/${_id}`;

        return this._httpClient.patch<ResponseApiDto<void>>(url, null);
    }

    /**
     * Cancela a geração do PDF do documento
     * @param _id ID of document
     * @returns Observable of ResponseApiDto<void>
     */
    public cancel(_id: string): Observable<ResponseApiDto<void>> {
        const url = `${environment.API_BASE}${this.prefix}/cancel/${_id}`;

        return this._httpClient.patch<ResponseApiDto<void>>(url, null);
    }
}
